import { z } from "zod";
export const HealthStatusSchema = z.enum(["ok", "degraded", "down"]);
/** GET /api/v1/health/live and /api/v1/health/ready */
export const HealthResponseSchema = z.object({
    status: HealthStatusSchema,
    checks: z.record(z.string(), HealthStatusSchema).optional(),
});
//# sourceMappingURL=health.js.map